import { useEffect, useRef } from 'react'
import type { ChatMessage } from '../types/agent.types'
import { AgentMessage } from './agent-message'

type Props = {
  messages: ChatMessage[]
}

export function AgentMessageList({ messages }: Props) {
  const bottomRef = useRef<HTMLDivElement>(null)

  const lastMessageText = messages[messages.length - 1]?.text

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages.length, lastMessageText])

  return (
    <div className="flex-1 overflow-y-auto px-4 py-4 space-y-3">
      {messages.map((message) => (
        <AgentMessage key={message.id} message={message} />
      ))}
      <div ref={bottomRef} />
    </div>
  )
}
